import profileService from '@/services/http/profile/ProfileService'
import HttpUnAuthenticatedError from '@/objects/Exceptions/HttpUnAuthenticatedError'
import HttpError from '@/objects/Exceptions/HttpError'

const defaultState = () => (getdefaultProfile)

const getdefaultProfile = () => {
  if (process.env.AUTH_DISABLED === 'true') {
    return {
      authenticated: true, // Undefined = still needs to be checked by the server, true = true, false = false
      profile: {
        title: 'Mr',
        email: 'edwin@lamalama.nl',
        gender: 'Male',
        first_name: 'Edwin',
        last_name: 'Fennema',
        onboarded_at: undefined,
        phone: '06123456789'
      }
    }
  }

  return {
    authenticated: undefined, // Undefined = still needs to be checked by the server, true = true, false = false
    profile: {
      title: undefined,
      email: undefined,
      gender: undefined,
      first_name: undefined,
      last_name: undefined,
      onboarded_at: undefined,
      phone: undefined
    }
  }
}

export const userprofile = () => {
  return {
    namespaced: true,
    state: defaultState(),
    mutations: {
      SET_PROFILE (state, profile) {
        state.profile = {...state.profile, ...profile}
        state.authenticated = true
      },
      SET_EMAIL (state, email) {
        state.profile.email = email
        state.authenticated = true
      },
      RESET_PROFILE (state) {
        state.profile = {...getdefaultProfile().profile}
        state.authenticated = false
      },
      SET_CURRENT_RESERVATION (state, reservation) {
        state.reservations = reservation
      }
    },
    actions: {
      async fetchProfile ({commit}) {
        let userProfile
        try {
          userProfile = await profileService.fetchProfile()
        } catch (error) {
          throw new HttpUnAuthenticatedError('Je bent niet ingelogd')
        }
        commit('SET_PROFILE', userProfile)
        return userProfile
      },
      requestLogin ({commit}, payload) {
        return profileService.requestLogin(payload)
          .catch(error => {
            throw HttpError.parseError(error)
          })
      },
      async login ({commit}, payload) {
        const userProfile = await profileService.login(payload)
        commit('SET_PROFILE', userProfile)
        return userProfile
      },
      async onboardingCompleted ({commit}) {
        const userProfile = await profileService.onboardingCompleted()
        commit('SET_PROFILE', userProfile)
        return userProfile
      },
      getReservations ({ commit }) {
        return profileService.getReservations()
          .then(response => {
            commit('SET_RESERVATIONS', response.reservations)
            commit('SET_CURRENT_RESERVATION', response.reservations[0])
          })
      },
      async logout({commit}) {
        return profileService.logout()
          .then(response => {
            commit('RESET_PROFILE')
            return response
          })
      }
    }
  }
}
